import { IProgressNodeData } from '../../../progress-bar/interfaces/progress-node-data.interface';

export interface ActivityState {
  activityId: string;
  startTime: string; //time the activity was started
  secondsToComplete: number; //time in seconds to complete the activity
  lastOpened: string; //last time the activity was opened, or ‘date complete’ for completed activities
  starsEarned?: number; //only used for complete, can be calculated from answer states NOT USED
  score?: number; //only used for complete, can be calculated from answer states
  isAssignment: boolean; //needed for incomplete
  inboxActivityId?: string;
  inboxAssignmentId?: string;
  progressNodes: IProgressNodeData[]; //can be constructed in microlesson, but not easily on SE
}
